/* eslint-disable react/prop-types */
import * as React from "react";
import ModalUI from "../../../components/ModalUI";
import { useEffect, useState } from "react";
import { getSingleGhollak } from "../../../services/ghollak.routes";
import { toast } from "react-toastify";
import Loading from "../../../components/Loading";
import MoreInfoTabs from "./MoreInfoTabs";


export default function GhollakMoreInfoModal({ modalInfo, closeModal }) {
  const [loading, setLoading] = useState(false);
  const [singleGhollak, setSingleGhollak] = useState();

  useEffect(() => {
    if (modalInfo?.item) {
      setLoading(true);
      getSingleGhollak(modalInfo.item.id, (isOk, data) => {
        setLoading(false);
        if (!isOk) {
          return toast.error(data.message);
        } else {
          setSingleGhollak(data);
        }
      });
    }
  }, [modalInfo]);
  return (
    <ModalUI open={modalInfo.state} handleClose={closeModal} style={{ minWidth: "600px" }}>
      <Loading loading={loading} />
      {singleGhollak && <MoreInfoTabs singleGhollak={singleGhollak}/>}
    </ModalUI>
  );
}
